export class Debounce {
  #stackDebounced = new Map();

  #callback = null;

  constructor(callback) {
    this.#callback = callback;
  }

  #debounce(delay) {
    let timeoutId;

    return (...args) => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => this.#callback(...args), delay);
    };
  }

  debounceEvent(errorMessage, delay = 1000) {
    if (!this.#stackDebounced.has(errorMessage)) {
      this.#stackDebounced.set(errorMessage, this.#debounce(delay));
    }

    return this.#stackDebounced.get(errorMessage);
  }
}
